export default __webpack_public_path__ + "static/media/Gallery3.80712132.jpeg";